// ✅ React
import React, { Fragment } from "react";

// ✅ Custom UI Components
import H3Text from "@Uilib/h3Text";
import HideComponent from "../../../../Common/RestrictedAccess/HideComponent";
import ViewDocumentFooterDetails from "@Components/Common/ViewDocFooterLeftSection";

// ✅ Helpers / Utilities
import Helpers from "../../../../../apis/helpers";
import { renderCharges, splitChargesData } from "../helper";

function ViewCreditNoteFooter({
  currentCN,
  fileList,
  getAttachmentByIdLoading,
  updateAttachmentLoading,
  handleFileChange,
  isDataMaskingPolicyEnable,
  isHideSellingPrice,
  MONEY,
  user,
  isReturnSlip,
  updateAttachment,
  getAttachmentById,
  setFileList,
  setIsGetAttachment,
  selectedCN,
}) {
  return (
    <div className="view-document__totals-wrapper">
      <ViewDocumentFooterDetails
        remark={currentCN?.remark}
        narration={currentCN?.narration}
        fileList={fileList}
        disableAttachment={getAttachmentByIdLoading || updateAttachmentLoading}
        onFileChange={ (fileListData) => handleFileChange({ fileListData, currentCN, updateAttachment, getAttachmentById, setFileList, setIsGetAttachment, selectedCN, })}
        canUpdateAttachment={Helpers.getPermission(
          Helpers.permissionEntities.CREDIT_NOTE,
          Helpers.permissionTypes.UPDATE,
          user
        )}
        termsAndConditions={currentCN?.terms_and_conditions}
      />
      {isDataMaskingPolicyEnable && isHideSellingPrice ? (
        <HideComponent
          style={{
            width: "fit-content",
          }}
        />
      ) : (
        !isReturnSlip && (
          <div className="view-document__totals">
            <div className="view-document__totals-field">
              <H3Text
                text="Total Amount"
                className="view-document__totals-field-name"
              />
              <H3Text
                text={MONEY(
                  currentCN?.cn_base_price,
                  currentCN?.org_currency_info?.currency_code
                )}
                className="view-document__totals-field-value"
              />
            </div>
            <div className="view-document__totals-field">
              <H3Text
                text="Discount"
                className="view-document__totals-field-name"
              />
              {currentCN?.cn_discount > 0 ? (
                <H3Text
                  text={`(-) ${MONEY(
                    currentCN?.cn_discount,
                    currentCN?.org_currency_info?.currency_code
                  )}`}
                  className="view-document__totals-field-value danger-text"
                />
              ) : (
                <H3Text
                  text={MONEY(
                    currentCN?.cn_discount,
                    currentCN?.org_currency_info?.currency_code
                  )}
                  className="view-document__totals-field-value"
                />
              )}
            </div>
            {renderCharges({
              charge: splitChargesData(currentCN?.other_charges)
                ?.chargeWithTaxName,
              MONEY,
              currentCN,
            })}
            <div className="view-document__totals-field">
              <H3Text
                text="Taxable Amount"
                className="view-document__totals-field-name"
              />
              <H3Text
                text={MONEY(
                  currentCN?.cn_base_price - currentCN?.cn_discount,
                  currentCN?.org_currency_info?.currency_code
                )}
                className="view-document__totals-field-value"
              />
            </div>

            {currentCN?.tax_info?.map((tax, i) => (
              <div className="view-document__totals-field" key={i}>
                <H3Text
                  text={tax?.tax_type_name}
                  className="view-document__totals-field-name"
                />
                <H3Text
                  text={MONEY(
                    tax?.tax_amount,
                    currentCN?.org_currency_info?.currency_code
                  )}
                  className="view-document__totals-field-value"
                />
              </div>
            ))}

            {currentCN?.tcs_id && (
              <div className="view-document__totals-field">
                <H3Text
                  text="TCS"
                  className="view-document__totals-field-name"
                />
                <H3Text
                  text={MONEY(
                    currentCN?.tcs_info?.tcs_amount || 0,
                    currentCN?.org_currency_info?.currency_code
                  )}
                  className="view-document__totals-field-value"
                />
              </div>
            )}
            {/* {!!currentCN?.other_charges?.length && currentCN?.other_charges?.map((otherCharge, i) => (
                          <div key={i} className="view-document__totals-field">
                            <H3Text text={otherCharge?.charge_name.toProperCase()} className="view-document__totals-field-name" />
                            <H3Text text={MONEY((otherCharge?.charge_amount), currentCN?.org_currency_info?.currency_code)} className="view-document__totals-field-value" />
                          </div>
                        ))} */}
            {renderCharges({
              charge: splitChargesData(currentCN?.other_charges)
                ?.chargeWithoutTaxName,
              MONEY,
              currentCN,
            })}
            <div className="view-document__totals-field">
              <H3Text
                text="Round Off"
                className="view-document__totals-field-name"
              />
              {currentCN?.cn_round_off < 0 ? (
                <H3Text
                  text={`(-) ${MONEY(
                    Math.abs(currentCN?.cn_round_off),
                    currentCN?.org_currency_info?.currency_code
                  )}`}
                  className="view-document__totals-field-value danger-text"
                />
              ) : (
                <H3Text
                  text={MONEY(
                    Math.abs(currentCN?.cn_round_off),
                    currentCN?.org_currency_info?.currency_code
                  )}
                  className="view-document__totals-field-value"
                />
              )}
            </div>
            {currentCN?.total_payment_made ? (
              <div className="view-document__totals-field">
                <H3Text
                  text="Refund"
                  className="view-document__totals-field-name"
                />
                <H3Text
                  text={`(-) ${MONEY(
                    currentCN?.total_payment_made,
                    currentCN?.org_currency_info?.currency_code
                  )}`}
                  className="view-document__totals-field-value danger-text"
                />
              </div>
            ) : (
              <Fragment />
            )}
            {currentCN?.applied_credits ? (
              <div className="view-document__totals-field">
                <H3Text
                  text="Applied Credits"
                  className="view-document__totals-field-name"
                />
                <H3Text
                  text={`(-) ${MONEY(
                    currentCN?.applied_credits,
                    currentCN?.org_currency_info?.currency_code
                  )}`}
                  className="view-document__totals-field-value danger-text"
                />
              </div>
            ) : (
              <Fragment />
            )}
            <div className="view-document__totals-field view-document__totals-field-total">
              <H3Text
                text="Total Credits"
                className="view-document__totals-field-name"
              />
              <H3Text
                text={MONEY(
                  currentCN?.cn_grand_total -
                              currentCN?.total_payment_made -
                              currentCN?.applied_credits,
                  currentCN?.org_currency_info?.currency_code
                )}
                className="view-document__totals-field-value"
              />
            </div>
          </div>
        )
      )}
    </div>
  );
}

export default ViewCreditNoteFooter;